export default __webpack_public_path__ + "static/media/plantas catarina.85da4690.jpg";